import { ApplicationRef, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, first, mergeMap, switchMap, take, tap, interval } from 'rxjs';
import { AuthService } from '@uw/core/services/auth.service';
import { Roles } from './core/enums/role.enum';
import { MatDialog } from '@angular/material/dialog';
import { UnitedWay } from './core/models/unitedway.model';
import { SwitchUwModalComponent } from './modules/auth/modals/switch-uw-modal/switch-uw-modal.component';
import { environment } from '@uw-env/environment';
import { Keepalive } from '@ng-idle/keepalive';
import { SwUpdate } from '@angular/service-worker';
import { IdleLogoutService } from '@uw/core/services/idle-logout.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    host: {
        class: 'uw-root',
    },
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(
    private readonly _translateService: TranslateService,
    private readonly title: Title,
    private readonly _route: ActivatedRoute,
    private readonly _authService: AuthService,
    private readonly _router: Router,
    private readonly _dialog: MatDialog,
    private idleLogoutService: IdleLogoutService,
    private keepalive: Keepalive,
    private update: SwUpdate,
    private appRef: ApplicationRef,
  ) {
      this.updateClient();
      this.checkUpdate();
     // Git Brnach
     //more changes
     // set keepalive parameters, omit if not using keepalive
     this.keepalive.interval(environment.ngIdleConfig.keepaliveInterval); // will ping at this interval while not idle, in seconds 10 mins

     this.keepalive.onPing.pipe(
      filter(_ => !!localStorage.getItem('token')),
      switchMap(_ => this._authService.refreshToken(localStorage.getItem('token')!))
    ).subscribe(
      (token) => {
        localStorage.setItem('token', token);
      },
      err => {
        localStorage.clear();
        window.location.href = `${environment.donorSiteUrl}?refreshTokenFailed=true`;
      }
    );

    // If on admin site and no token available, this scenario can occur if the user has multiple admin tabs open
    // and the refresh token failure on one tab causes token to get removed from
    // local storage. the user should be redirected to login page.
    this.keepalive.onPing.pipe(
      filter(_ => !localStorage.getItem('token')),
    ).subscribe(
      () => {
        window.location.href = `${environment.donorSiteUrl}?refreshTokenFailed=true`;
      },

    );

    this.idleLogoutService.init();
  }

  updateClient() {
    if (!this.update.isEnabled) {
      return;
    }

    this.update.versionUpdates.subscribe((event)=>{
      if (event.type == 'VERSION_DETECTED'){
        this.update.activateUpdate().then(()=> location.reload());
      }
    });
  }

  checkUpdate() {
    if (!this.update.isEnabled) return;
    this.appRef.isStable.pipe(
      take(1),
    ).subscribe(counter => {
      this.update.checkForUpdate();
    });

    this.appRef.isStable.pipe(
      take(1),
      switchMap(()=> interval(300000)),
    ).subscribe(counter => {
      this.update.checkForUpdate();
    });
  }

  ngOnInit() {
    const lang = localStorage.getItem('lang');
    this._translateService.use(lang ?? 'en');
    this._translateService.get('page_title').subscribe((translatedTitle) => {
      this.title.setTitle(translatedTitle);
    });

  }

  openUnitedWaySwitcherModal(){
    return this._dialog.open(SwitchUwModalComponent, {
          panelClass: 'uw-dialog-panel',
          disableClose: true
        })
          .afterClosed()
          .pipe(
            switchMap((unitedWay: UnitedWay) => this._authService.switchContext(unitedWay.unitedWayId)
            .pipe(tap(_ =>   this._router.navigate(['/private']))))
          );
  }
}
